'use client'

import { useEffect } from "react"

const RELOAD_GUARD_KEY = "hrx_chunk_reload_at"
const RELOAD_GUARD_WINDOW_MS = 10000

function isChunkLoadError(message) {
  if (!message) return false
  return /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/i.test(message)
}

function reloadOnce() {
  const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0)
  if (Date.now() - last < RELOAD_GUARD_WINDOW_MS) return
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
  window.location.reload()
}

export default function ChunkErrorReload() {
  useEffect(() => {
    const onError = (event) => {
      if (isChunkLoadError(event?.message)) reloadOnce()
    }
    const onRejection = (event) => {
      const message = event?.reason?.message || String(event?.reason || "")
      if (isChunkLoadError(message)) reloadOnce()
    }
    window.addEventListener("error", onError)
    window.addEventListener("unhandledrejection", onRejection)
    return () => {
      window.removeEventListener("error", onError)
      window.removeEventListener("unhandledrejection", onRejection)
    }
  }, [])

  return null
}
